var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 32",
    "aria-label": "Mastercard",
    role: "img",
    focusable: "false",
    style: {
      display: "block",
      height: 33,
      width: 33
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F26122",
    fillRule: "nonzero",
    d: "M17.447 9.124L26.579 9.124 26.579 23.798 17.447 23.798z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA1D25",
    fillRule: "nonzero",
    d: "M21.974 23.798a9.536 9.536 0 0 1-5.843 1.998c-2.539-.025-4.96-1.018-6.736-2.761-1.777-1.757-2.763-4.111-2.737-6.568-.026-2.456.96-4.81 2.737-6.567 1.776-1.756 4.197-2.75 6.736-2.762 2.132 0 4.185.7 5.843 1.998-2.277 1.795-3.606 4.493-3.606 7.331 0 2.851 1.33 5.537 3.606 7.331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F69E1E",
    fillRule: "nonzero",
    d: "M37.316 16.454c.026 2.457-.96 4.811-2.737 6.568-1.776 1.756-4.197 2.749-6.737 2.762-2.131 0-4.184-.7-5.842-1.998 2.276-1.795 3.605-4.493 3.605-7.332 0-2.85-1.329-5.536-3.605-7.33a9.535 9.535 0 0 1 5.842-1.999c2.54.026 4.96 1.019 6.737 2.762a9.07 9.07 0 0 1 2.737 6.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B0B0",
    d: "M2.036 1C1.468 1 1 1.466 1 2.05v27.9c0 .584.468 1.05 1.036 1.05h39.928c.568 0 1.036-.466 1.036-1.05V2.05C43 1.466 42.532 1 41.964 1H2.036zM0 2.05C0 .922.907 0 2.036 0h39.928C43.093 0 44 .922 44 2.05v27.9c0 1.128-.907 2.05-2.036 2.05H2.036A2.043 2.043 0 0 1 0 29.95V2.05z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMastercard);
export default __webpack_public_path__ + "static/media/card-mastercard.c42331e899eed1c55551ded3da224a51.svg";
export { ForwardRef as ReactComponent };